import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    align-items: center;
    background: linear-gradient(180deg, #f7fafc 0%, ${({ theme }) => theme.body} 46%, #f8f7f2 100%);
    color: ${({ theme }) => theme.text};
    display: flex;
    // flex-direction: column;
    // justify-content: center;
    // height: 100vh;
    // margin: 0;
    // padding: 0;
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    transition: all 0.25s linear;
  }

  #root {
    width: 100%;
  }

  ::selection {
    color: #ffffff;
    background: #05505e;
  }

  a,
  button {
    -webkit-tap-highlight-color: transparent;
  }

  a:focus-visible,
  button:focus-visible {
    outline: 2px solid rgba(5, 80, 94, 0.42);
    outline-offset: 3px;
  }`;
